import { useQuery } from '@apollo/client'
import { GetProcessStatuses } from 'shared/graphql/candidateProcessStatus.gql'
import { useMemo } from 'react'

export const useProcessStatuses = () => {
    const { data, loading, error } = useQuery(GetProcessStatuses)

    const processStatusMap = useMemo(() => {
        if (!data?.processStatuses) return new Map()

        const map = new Map()
        data.processStatuses.forEach((status) => {
            map.set(status.id, status)
        })
        return map
    }, [data?.processStatuses])

    return {
        processStatuses: data?.processStatuses || [],
        processStatusMap,
        loading,
        error,
    }
}
